import { render } from "./MySimsSection.vue?vue&type=template&id=e072e6f8&scoped=true"
import script from "./MySimsSection.vue?vue&type=script&lang=js"
export * from "./MySimsSection.vue?vue&type=script&lang=js"

import "./MySimsSection.vue?vue&type=style&index=0&id=e072e6f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e072e6f8"]])

export default __exports__